import React, { useRef } from 'react'
import { Link } from 'gatsby'
import resolveLink from 'src/utils/resolveLink';
import InView from 'src/utils/InView';

const SimpleThreeColumnItem = ({props}) => {
    const ref = useRef()
    const isVisible = InView(ref, true)
    
    const children = 
        <>
            <img src={props.icon?.filename} alt={props.icon?.alt} className="max-w-[70px] mb-4"/>
            <p className="text-xl font-semibold mb-2">{props.title}</p>
            <dd className="md:text-base text-sm text-darkblue-600">{props.description}</dd>
        </>

    // Tailwind was glitching too much when I put in odd: classes so I had to go down this route (1 is the middle one)
    const classes = 
        `block bg-white xl:p-9 p-6 rounded-lg shadow-lg duration-300
        ${props.index === 1 ? 'lg:translate-y-12' : ''}
        ${props.index === 1 && props.target?.cached_url ? 'lg:hover:translate-y-10' : ''}
        ${props.index !== 1 && props.target?.cached_url ? 'lg:hover:-translate-y-2' : ''}`

    const animationClasses = `duration-500 opacity-0 translate-y-1/2 ${isVisible && 'opacity-100 !translate-y-0'}`

    // If it has a link target
    return props.target?.cached_url ? (
        <div ref={ref} className={animationClasses} style={{transitionDelay: `${props.index}00ms`}}>
            <Link
                to={resolveLink(props.target?.cached_url)}
                className={classes}
            >
                {children}
            </Link>
        </div>
    ) :
    (
        <div ref={ref} className={animationClasses} style={{transitionDelay: `${props.index}00ms`}}>
            <div className={classes}>
                {children}
            </div>
        </div>
    )
}

export default SimpleThreeColumnItem